import { OverrideBehaviour, createFlagOverridesFromMap } from 'configcat-react';

export const flagOverridesMap: { [key: string]: boolean | string | number } =
  {};

export const flagOverrides = createFlagOverridesFromMap(
  flagOverridesMap,
  OverrideBehaviour.LocalOverRemote,
  true
);
